import { useEffect } from 'react';
import { useModal } from '@/providers/modal';
import { MODAL_IDS } from '@/kit/Modal/keys';

const LS_KEY = 'fpg_assets_warning_show';

export const useFpgAssetsRequestWarning = () => {
  const { openSingleModal } = useModal();

  useEffect(() => {
    if (localStorage.getItem(LS_KEY)) return;
    localStorage.setItem(LS_KEY, '1');
    openSingleModal(MODAL_IDS.fpg_assets_warning_modal);
  }, []);

  return null;
};
